import './StreamingStatus.css';

export default function StreamingStatus({ active, error }: { active: boolean; error?: string }) {
  if (error) return <p className="streaming-error" role="alert">{error}</p>;
  if (!active) return null;
  return (
    <div className="streaming-status" role="status">
      <span className="streaming-cursor" aria-hidden="true" />
      <span>正在生成，内容将持续更新</span>
      <span className="streaming-dots" aria-hidden="true"><i /><i /><i /></span>
    </div>
  );
}
